import { render, staticRenderFns } from "./DoorFamilyCategory.vue?vue&type=template&id=49e6d76e&"
import script from "./DoorFamilyCategory.vue?vue&type=script&lang=ts&"
export * from "./DoorFamilyCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports